/**
 * Interface for the data/content that will be recorded
 */
export var ConsoleDataType;
(function (ConsoleDataType) {
    ConsoleDataType[ConsoleDataType["Info"] = 0] = "Info";
    ConsoleDataType[ConsoleDataType["Error"] = 1] = "Error";
    ConsoleDataType[ConsoleDataType["InProgress"] = 2] = "InProgress";
    ConsoleDataType[ConsoleDataType["Warning"] = 3] = "Warning";
})(ConsoleDataType || (ConsoleDataType = {}));
